import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';

export const excludeCampaignPostsRequestSchema = z.object({
  campaign_post_ids: z.array(z.string().trim().min(1)).min(1),
});

export type ExcludeCampaignPostsRequest = z.infer<typeof excludeCampaignPostsRequestSchema>;

export async function ExcludeCampaignPosts(
  campaignId: string,
  request: ExcludeCampaignPostsRequest,
  signal?: AbortSignal,
): Promise<void> {
  const parsedRequest = excludeCampaignPostsRequestSchema.parse(request);
  await socialApiClient.post(`campaigns/${campaignId}/posts/exclude`, {
    json: parsedRequest,
    signal,
  });
}
